
<template>
  <div>
    <div class="header-btn-icon pointer" @click="showLocalVideo">
      <img :src="require('@/svg/local_video.svg')" v-if="videoStatus == 'active'" />
      <template v-else-if="videoStatus == 'inactive'">
        <img :src="require('@/svg/video_main.svg')" v-if="authVideo == 0 && avctl == 0" />
        <img :src="require('@/svg/local_video_close.svg')" v-else />
      </template>
      <img :src="require('@/svg/local_video_close2.svg')" v-else />
    </div>
    <!--本地视频-->
    <localVideo v-show="showLocal" @closeLocal="closeLocalVideo" />
  </div>
</template>
<script>
import localVideo from '@/components/local/localVideo';
import Bus from '@/components/doc/bus';
import vClickOutside from 'v-click-outside';
export default {
  name: 'videoControl',
  data() {
    return {
      showLocal: false
    };
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    localVideo
  },
  computed: {
    videoStatus() {
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.mediaStatus
        ? this.$store.getters.selfParticipant.mediaStatus.video
        : 'disabled';
    },
    authVideo() {
      return (
        this.$store.getters.meetStatusInfo &&
        this.$store.getters.meetStatusInfo.groupInfo &&
        this.$store.getters.meetStatusInfo.groupInfo.video
      );
    },
    avctl() {
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.avctl;
    },
  },
  methods: {
    showLocalVideo() {
      this.showLocal =  !this.showLocal;
      if (this.showLocal) {
        Bus.$emit('getLocalVideo');
      }
    },
    videoOutLocal() {
      this.showLocal = false;
    },
    closeLocalVideo() {
      this.showLocal = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.header-btn-icon {
  width: 32px;
  height: 32px;
  background: rgba(221, 221, 221, 0.1);
  border-radius: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}
[data-theme='Orange'] .header-btn-icon {
  background: rgba(221, 221, 221, 0.5);
}
</style>
